import { FormattedMessage } from 'react-intl';

import Counter from '../../../../components/Counter/Counter';
import { useResponsive } from '../../../../context/ResponsiveContext';
import Price from '../../../Price/Price';
import DetailsCard from '../../DetailsCard';
import {
  MetadataItemStyled,
  MetadataLabelStyled,
  MetadataRowStyled,
} from '../../DetailsCard.styled';
import { LimitMessageStyled } from './CarbonOffsetCard.styled';

type CarbonOffsetCardPropsT = {
  name: string;
  qty: number;
  type: string;
  impact: string;
  country: string;
  price: string | number;
  image: string;
  description: string;
  maxAvailable: number;
  onChangeCounter: (val: number) => void;
};

const CarbonOffsetCard: React.FC<CarbonOffsetCardPropsT> = ({
  name,
  type,
  impact,
  country,
  price,
  description,
  image,
  qty,
  maxAvailable,
  onChangeCounter,
}) => {
  const { isMobile } = useResponsive();

  const renderMetaData = () => (
    <>
      <MetadataRowStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.type" defaultMessage="Type" />:{' '}
          </MetadataLabelStyled>
          {type}
        </MetadataItemStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.priceTonne" defaultMessage="Price/tonne" />:{' '}
          </MetadataLabelStyled>
          <Price amount={price} />
        </MetadataItemStyled>
      </MetadataRowStyled>
      <MetadataRowStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.impact" defaultMessage="Impact" />:{' '}
          </MetadataLabelStyled>
          {impact}
        </MetadataItemStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.country" defaultMessage="Country" />:{' '}
          </MetadataLabelStyled>
          {country}
        </MetadataItemStyled>
      </MetadataRowStyled>
    </>
  );

  const renderCounter = () => (
    <>
      <Counter min={0} max={maxAvailable} value={qty} onChange={onChangeCounter} />

      <LimitMessageStyled>
        <FormattedMessage
          id="foundItem.availableNumber"
          defaultMessage="{count}t available"
          values={{
            count: maxAvailable,
          }}
        />
      </LimitMessageStyled>
    </>
  );

  return (
    <DetailsCard
      title={name}
      imageUrl={image}
      description={description}
      rowsNumber={isMobile ? 2 : 4}
      childrenMeta={renderMetaData()}
      childrenRightCol={renderCounter()}
    ></DetailsCard>
  );
};

export default CarbonOffsetCard;
